<template>
    <BaseCard
        v-editable="item.vEditable"
        :card="item"
        main-classes="flex flex-col rounded-xl bg-white pt-4 text-left shadow-card-lg !no-underline"
        image-container-classes="h-auto"
    >
        <template #image>
            <div class="ml-6 mt-2 flex">
                <StoryblokImage
                    class="aspect-auto"
                    :class="[imageSizeCss]"
                    :src="item.image.src"
                    :alt="item.image.alt || ''"
                    sizes="360px"
                />
            </div>
        </template>

        <template #subtitle> <span class="hidden"></span></template>
        <template #title>
            <div>
                <div
                    v-if="item.shortDescription"
                    class="transition-colors' mb-2 text-sm font-semibold uppercase tracking-wide text-drip"
                >
                    {{ item.shortDescription }}
                </div>
            </div>
            <div
                class="mb-6 text-[20px] font-bold text-grind transition-colors"
            >
                {{ item.title }}
            </div>
        </template>
        <template #footer>
            <div class="transition-colors group-hover:!underline">
                <div
                    v-if="item.link"
                    :class="[
                        'flex flex-1 flex-col justify-end text-brew transition-colors',
                        item.link && 'md:group-hover:underline',
                    ]"
                >
                    {{ item.link.label }}
                </div>
            </div>
        </template>
    </BaseCard>
</template>

<script setup lang="ts">
import DifferentiatorGridItemType from '~/types/DifferentiatorGridItemType';
import BaseCard from '~/components/ui/BaseCard.vue';

const props = defineProps<{
    item: DifferentiatorGridItemType;
}>();

const imageSizeCss = computed(() => {
    let css = 'h-[50px]';
    if (props.item.imageSize) {
        if (props.item.imageSize === 'large') {
            css = 'h-[240px]';
        } else if (props.item.imageSize === 'medium') {
            css = 'h-[120px]';
        }
    }
    return css;
});
</script>
